module.exports = __webpack_public_path__ + "static2024-7-11/img/next-red-tag.5164c136.gif";